
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/dining/reservation",
      function () {
        return require("private-next-pages/[hid]/dining/reservation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/dining/reservation"])
      });
    }
  